// import React from 'react';
// import { Link } from 'react-router-dom';

// // CSS
// import './company-logo.css';

// const CompanyLogo = () => {
//   return (
//     <Link to="/" className="company-logo">
//       <span className="ekhoni">Ekhoni</span>{' '}
//       <span className="khabo">Khabo</span>
//     </Link>
//   );
// };

// export default CompanyLogo;

import React from "react";
import { Link } from "react-router-dom";

// CSS
import "./company-logo.css";

// Brand mark - cream cyclist on a terracotta roundel, from the official
// logo pack. Self-contained circular badge, so it reads fine on both the
// light header and the dark footer without needing a separate variant.
import logoMark from "../../assets/brand/mark-primary.svg";

const CompanyLogo = () => {
  return (
    <Link to="/" className="company-logo">
      <img src={logoMark} alt="Ekhoni Khabo" className="logo-image" />
      <span className="logo-text">
        <span className="ekhoni">Ekhoni</span>{" "}
        <span className="khabo">Khabo</span>
      </span>
    </Link>
  );
};

export default CompanyLogo;
